/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Voucher } from './types';

const buscarVouchersUsuario = (usuariosId: number): AxiosPromise<Voucher[]> => xhr
    .get(`/usuarios/${usuariosId}/vouchers`);

export default buscarVouchersUsuario;
